import React, { useContext, useEffect, useState } from 'react';
import { apiRoutes } from '../../AppSettings';
import { AuthContext } from '../../contexts/AuthContext';
import Breadcrumb from '../shared/Breadcrumb';
import AppoinmentList from './shared/AppoinmentList';
import DoctorList from './shared/DoctorList';
import PatientList from './shared/PatientList';
import SideNav from './shared/SideNav';
import axios from 'axios';

import Raphael from 'raphael';

import 'jquery/src/jquery.js';
import 'morris.js/morris.css';
import 'morris.js/morris.js';
import Morris from 'morris.js/morris.js'

window.Raphael = Raphael;

const AdminDashboard = () => {
    const { userState } = useContext(AuthContext);
    const [count, setCount] = useState({});
    
    //window.Raphael = Raphael;

    useEffect(() => {
        const options = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'bearer ' + userState.token
            }
        };

   //    console.log( document.getElementById("morrisArea"));

        axios.get(apiRoutes.GetAdminDashboardCount, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                setCount(data);
            }
        }, (error) => {
            console.log(error);
        });

        axios.get(apiRoutes.GetChartData, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
          
                new window.Morris.Area({
                    element: 'morrisArea',
                    data: data.areaChartItems,
                    xkey: 'year',
                    ykeys: ['revenue'],
                    labels: ['Revenue'],
                    lineColors: ['#1b5a90'],
                    lineWidth: 2,
                    fillOpacity: 0.5,
                    gridTextSize: 10,
                    hideHover: 'auto',
                    resize: true,
                    redraw: true
                });
        
               new window.Morris.Line({
                    element: 'morrisLine',
                    data: data.lineChartItems,
                    xkey: 'year',
                    ykeys: ['doctors', 'patients'],
                    labels: ['Doctors', 'Patients'],
                    lineColors: ['#1b5a90','#ff9d00'],
                    lineWidth: 1,
                    gridTextSize: 10,
                    hideHover: 'auto',
                    resize: true,
                    redraw: true
                });
            }
        }, (error) => {
            console.log(error);
        });

       
    }, []);

  

    return ( 
        <div>
            <Breadcrumb title="Dashboard"></Breadcrumb>
                    <div className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                                    <SideNav applyCssFor='admindashboard' />
                                </div>
                                <div className="col-md-7 col-lg-8 col-xl-9">
                
                                <div className="row">
                                    <div className="col-xl-3 col-sm-6 col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="dash-widget-header">
                                                    <span className="dash-widget-icon text-primary border-primary">
                                                        <i className="fe fe-users"></i>
                                                    </span>
                                                    <div className="dash-count">
                                                        <h3>{count.doctorsCount}</h3>
                                                    </div>
                                                </div>
                                                <div className="dash-widget-info">
                                                    <h6 className="text-muted">Doctors</h6>
                                                    <div className="progress progress-sm">
                                                        <div className="progress-bar bg-primary w-50"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6 col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="dash-widget-header">
                                                    <span className="dash-widget-icon text-success">
                                                        <i className="fe fe-credit-card"></i>
                                                    </span>
                                                    <div className="dash-count">
                                                        <h3>{count.patientsCount}</h3>
                                                    </div>
                                                </div>
                                                <div className="dash-widget-info">
                                                    
                                                    <h6 className="text-muted">Patients</h6>
                                                    <div className="progress progress-sm">
                                                        <div className="progress-bar bg-success w-50"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6 col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="dash-widget-header">
                                                    <span className="dash-widget-icon text-danger border-danger">
                                                        <i className="fe fe-money"></i>
                                                    </span>
                                                    <div className="dash-count">
                                                        <h3>{count.appoinmentsCount}</h3>
                                                    </div>
                                                </div>
                                                <div className="dash-widget-info">
                                                    
                                                    <h6 className="text-muted">Appointment</h6>
                                                    <div className="progress progress-sm">
                                                        <div className="progress-bar bg-danger w-50"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xl-3 col-sm-6 col-12">
                                        <div className="card">
                                            <div className="card-body">
                                                <div className="dash-widget-header">
                                                    <span className="dash-widget-icon text-warning border-warning">
                                                        <i className="fe fe-folder"></i>
                                                    </span>
                                                    <div className="dash-count">
                                                        <h3>${count.totalRevenue}</h3>
                                                    </div>
                                                </div>
                                                <div className="dash-widget-info">
                                                    
                                                    <h6 className="text-muted">Revenue</h6>
                                                    <div className="progress progress-sm">
                                                        <div className="progress-bar bg-warning w-50"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 col-lg-6">
                                    
                                        <div className="card card-chart">
                                            <div className="card-header">
                                                <h4 className="card-title">Revenue</h4>
                                            </div>
                                            <div className="card-body">
                                                <div id="morrisArea"></div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div className="col-md-12 col-lg-6">
                                    
                                        <div className="card card-chart">
                                            <div className="card-header">
                                                <h4 className="card-title">Status</h4>
                                            </div>
                                            <div className="card-body">
                                                <div id="morrisLine"></div>
                                            </div>
                                        </div>
                                        
                                    </div>	
                                </div>
                                <div className="row">
                                    <div className="col-md-6 d-flex">
                                        <div className="card card-table flex-fill">
                                            <div className="card-body">
                                                <DoctorList title="Doctors List" columnsToShow={["Doctor Name", "Speciality", "Earned", "Reviews"]} /> 
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-6 d-flex">
                                        <div className="card  card-table flex-fill">
                                            <div className="card-body">
                                                <PatientList title="Patients List" columnsToShow={["Patient Name", "Phone", "Last Visit", "Paid"]}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card card-table">
                                            <div className="card-body">
                                                <AppoinmentList />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>			
                        </div>
                    </div>
                </div>
        </div>			
    
     );
}
 
export default AdminDashboard;